export function formatUTCDate(date: string) {
  const get_date = new Date(date);
  const year = get_date.getUTCFullYear();
  const month = ("00" + (get_date.getUTCMonth() + 1)).slice(-2);
  const day = ("00" + get_date.getUTCDate()).slice(-2);
  return year + "/" + month + "/" + day;
}
